module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCI+PHBhdGggZmlsbD0iIzlFMzAzOSIgZD0iTTAgMGgxMjAwdjYwMEgwIi8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMjQwaDEyMDB2MTIwSDAiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/lva.svg
// module id = uuFZ
// module chunks = 0